import { render, staticRenderFns } from "./CashHeroInvestChart.vue?vue&type=template&id=c2e6bb56&scoped=true&"
import script from "./CashHeroInvestChart.vue?vue&type=script&lang=js&"
export * from "./CashHeroInvestChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e6bb56",
  null
  
)

export default component.exports